export default {
  common: {
    confirm: '确认',
    cancel: '取消',
    search: '搜索',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    more: '查看更多',
    loading: '加载中...',
    noData: '暂无数据',
    follow: '关注',
    alreadyFollow: '已关注',
    openAppDetails: '打开APP查看更多',
    noDataTip: '暂无数据',
    close: '关闭',
    know: '我知道了',
    end: '到底了',
    scores: "集换分"
  },
  error: {
    serverError: '服务器错误，请稍后重试',
    notFound: '页面不存在',
  },
  // 卡组分享页
  deckShare: {
    card_count: '张',
    player_count: '{count} 名选手',
    player: "选手",
    locale_participate: "参赛",
    scanQR: '扫描二维码查看此卡组',
    pm_deck_details_diagnosis_result_details: "查看AI分析"
  },
  // 应用推广
  appPromotion: {
    logoAlt: '集换社',
    openApp: '打开APP',
    downloadApp: '下载APP',
    cardTrade: '卡牌交易',
    topDeck: '上位卡组',
    priceEvaluation: '竞价送评',
    cardCommunity: '卡牌社区',
    gameTeaching: '游戏教学'
  },
  // 银行卡添加
  addBankCard: {
    cardNumber: '银行卡号',
    expirationDate: '有效期',
    cvv: '输入CVV',
    cvvTip: '位数字',
    submit: '确认添加',
    support: '支持的卡组织',
    safeTip: '您的信息是加密和安全的',
    confirm: '确定',
    dateTip: '请选择有效期',
    cardTip: '请输入银行卡号',
    unsupportedCard: '暂不支持该卡组织的银行卡',
    pm_card_bind_error_expired: '卡片已过有效期',
    pm_card_bind_tip_card_number_length: '卡号一般为15、16或19位数字',
    pm_card_bind_tip_cvv_length: '安全码为3-4位数',
    pm_card_bind_security_code_title: '请输入安全码',
  },
  // 个人主页
  userProfile: {
    userId: '用户ID: {id}',
    gameTags: '游戏标签',
    stats: {
      decks: '卡组',
      followers: '粉丝',
      following: '关注',
      posts: '帖子',
    }
  },
  // 卡包分享
  packShare: {
    increaseList: '涨幅榜单',
    rating: '评分',
    reviews: '{count} 评论',
    including: '包含卡牌',
    cardPriceFrom: '从',
    cards: '{count} 张卡牌',
    sharePack: '分享卡包',
  },
  // 卡片详情页
  cardDetail: {
    increaseList: '涨幅榜单',
    products: '商品',
    effectQA: '效果/问答',
    decks: '卡组',
    reviews: '评价',
    other: '其他',
    priceGuarantee: '价格公平保障',
    lastMonth: '最近一个月',
    appDetail: '详情在APP中查看',
    condition: '品相',
    priceTrade: '集换价格',
    priceTrend: {
      up: '上涨',
      down: '下跌'
    },
    currentPrice: '当前价格',
    series: '系列',
  },
  // 分享
  share: {
    priceTrend: '价格趋势',
    strategyInfo: '攻略信息',
    deckConstruction: '卡组构建',
    appDetail: '详情在APP中查看',
    scanQR: '扫描二维码 查看详情~',
    cardEverything: '卡牌有关的一切都在这里发生',
  },
  // 店铺
  shop: {
    userId: '用户ID: {id}',
    products: '商品',
    buyers: '买家',
    followers: '粉丝',
    onSale: '在售商品',
    sellerCredit: '集换信用',
    averageDeliveryTime: '平均发货时间',
  },
  // 心愿单
  wish: {
    wishList: '心愿单',
    wishCount: '张',
    wishTips: '立即购买并战斗！',
  },
  // 卡册
  cardAlbum: {
    hi: 'Hi, 我是{username}',
    desc: '这是我在集换社上拥有的集换卡册~',
    cardCount: '他拥有卡数',
    totalInvestment: '他的总投入',
    currentExchangePrice: '当前集换价总价值',
    syncTitle: '一起在集换社收藏卡牌，整理图鉴吧~',
    startExchange: '开启集换之旅',
    totalRevenue: '总收益',
    totalAssets: '总资产',
    totalCards: '总卡数',
    totalGraded: '总评级',
    priceLabel: '集换价格',
    stock: '库存',
    scanQR: '扫描二维码查看详情',
  },
  // 动态
  dynamic: {
    comments: '评论',
    game: '游戏',
    likes: '点赞',
    views: '浏览',
    includes: '包含',
    view_reply_count: '查看',
    reply_count: '条',
    reply: '回复',
    author: '作者',
    scanQR: '扫描二维码查看此动态',
    hot: '热度',
  },
  activity: {
    // 报名申请
    pleaseSelectGame: '请选择游戏',
    cardCarvingContent: '卡雕作品内容简介',
    privacyNotice: '您提交的个人信息将严格限定于"卡雕大赛"活动范围内使用。集换社郑重承诺，将依据《中华人民共和国个人信息保护法》等相关法律法规，采取最高标准的技术和管理措施，确保您的个人信息安全。',
    pleaseFill: '请填写',
    signupRecord: '报名记录',
    shareIntroduction: '可以和大家分享下您的作品介绍或创作故事~',
    submit: '提交报名',
    signupRecordEmpty: '暂无报名记录',
    selectGame: '选择游戏',
    selectGameTips: '请选择游戏，每个游戏仅可报名一次',
    alreadySignup: '已报名',
    game: '游戏',
    name: '姓名',
    phone: '手机号',
    wechat: '微信号',
    email: '邮箱',
    pleaseFillAll: '请填写完整',
    signupSuccess: '报名成功',
    allSignup: '已全部报名',
    inviteDesc: '立即登录集换社支持该作品～',
    // 邀请注册
    inviteinfo: '你的好友{username}正在邀请你加入集换社，给他的卡雕作品投票',
    userAgreement: '用户服务协议',
    privacyPolicy: '隐私政策',
    and: '和',
    agreementText: '提交注册信息即表示您已阅读并同意',
    googleLogin: 'Google 登录',
    appleLogin: 'Apple登录',
    downloadGoogleTip: '下载后请使用该谷歌账户登录即可获得投票次数~',
    downloadAppleTip: '下载后请使用该苹果账户登录即可获得投票次数~',
    selectArea: '选择地区',
    userAlreadyRegistered: '抱歉，该用户已注册或已被其他用户邀请~',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    inviteTip: '下载后请登录集换社，即可获得{count}次投票次数',
    // 作品详情
    userIdLabel: '集换号:',
    currentRank: '当前名次',
    currentVotes: '当前票数',
    votesUnit: '票',
    gapToPrevious: '距上一名还差',
    workIntroduction: '作品简介',
    shareAndCanvass: '分享拉票',
    vote: '投票',
    // 投票模块
    invite: '邀请函',
    uploadWork: '上传作品',
    signup: '报名参赛',
    inviteTitle: '中日卡雕国际邀请赛火热报名中...',
    inviteSubTitle: '立即报名，用卡雕惊艳整个卡牌圈！',
    voteRank: '投票排名',
    voteCount: '拥有票数',
    voteDetail: '票数详情',
    inviteRecord: '邀请记录',
    voteCountTip: '所有票均在自获得起的48小时后失效，请及时投票！',
    voteRecord: '投票记录',
    inviteFriend: '邀请好友参与投票',
    inviteFriendDescription: '邀请好友成功注册，即可获得',
    getVoteCount: '次投票机会',
    inviteFriendButton: '去邀请',
    rank: '{rank}排名',
    // 票数详情弹窗
    currentValidVotes: '当前拥有有效票数',
    expiredVotes: '已过期失效票数',
    voteNotice: '票数超过有效期（自获得起{hours}小时）后将自动失效，请及时投票！',
    // 投票弹窗
    voteModalTitle: '选择投票数量',
    remainingVotes: '剩余{count}票',
    insufficientVotes: '票数不足，无法投票',
    voteSuccess: '投票成功',
    voteFailed: '投票失败，请重试',
    // 邀请记录
    inviteSummary: '您已成功邀请：',
    inviteSummaryCount: '人，',
    inviteSummaryVotes: '共获得',
    invitePending: '待登录',
    inviteSuccess: '邀请成功',
    inviteExpired: '已失效',
    inviteUnknown: '未知',
    // 无票弹窗
    noVoteModalTitle: '抱歉，已经没有票可投啦～',
    inviteFriendToVote: '邀请好友参与投票',
    // 查看排名记录
    checkRankRecord: '查看{rank}排名记录',
    checkRankRecordShow: '{rank}排名记录',

    inviteDesc2: '卡雕大赛向你发起邀请！',
  },
  // 特商法
  specialLaw: {
    companyInfo: '店铺情报',
    companyAddress: '营业注册地址',
    officialWebsite: '官网链接',
    companyEmail: '客服邮箱',
    companyPhone: '客服电话',
    legalName: '法人姓名',
    productPrice: '销售价格',
    productPriceDisplay: '販売価格・送料は各商品ページに表示された金額（表示価格/消費税込）とします',
    paymentMethod: '支付方式',
    creditCard: 'クレジットカード（即時決済）',
    paymentTiming: '支付时间',
    creditCardTiming: 'クレジットカード：即時決済',
    shippingTiming: '发货时间',
    shippingTimingDesc: '支払い完了後 {time} （特別な取り決めがある場合は、最短期間を適用）',
    deliveryPeriod: '配送期间',
    deliveryPeriodDesc: '発送後1～7日以内',
    returnExchange: '关于退货和换货',
    returnExchangeAvailable: '是否可退货・换货',
    returnExchangePolicy: 'お客様のご都合による返品・交換は受け付けておりません。',
    defectiveProductPolicy: '不良品については、直接販売者へお問い合わせください。',
    customerSupportPolicy: '販売者からの回答が得られない場合など、下記案内のとおりカスタマーサポートまでご連絡ください。お客様のご要望に応じて、適切な対応を行います。',
    shopDetailInfo: '店铺情报',
    companyName: "企业名称",
    shopInfo: "店铺情报",
    returnExchangeText1: "お客様都合による商品のキャンセル・返品は原則として承っておりません",
    returnExchangeText2: "ご注文した商品と異なる商品が届いた場合、または明らかに商品が破損している場合に限り、直ちに詳細をご連絡いただき、処理させていただきます",
    returnExchangeText3: "期限を過ぎてからのご連絡は対応致しかねます"
  },
  // 路由标题
  routeTitle: {
    cardAlbum: '我的卡册',
    userProfile: '个人主页',
    userPoster: '个人海报',
    deckPoster: '卡组海报',
    deckShare: '卡组分享',
    searchRanking: '搜索榜单',
    addBankCard: '添加银行卡',
    packShare: '卡包分享',
    packPoster: '卡包海报',
    cardPoster: '单卡详情海报',
    cardDetail: '卡牌详情',
    shop: '店铺',
    wish: '心愿单分享',
    wishPoster: '心愿单海报',
    shopPoster: '店铺海报',
    dynamicShare: '动态分享',
    aiNews: '集换快讯',
    dynamicPoster: '动态海报',
    activity: '活动',
    activityPoster: '活动海报',
    cardCarving: '卡雕',
    activityRules: '卡雕规则',
    activityInvite: '呼朋唤友来投票',
    activitySignup: '报名信息填写',
    activityWorkDetail: '作品详情',
    activityRankRecord: '比赛排名',
    specialLaw: '店铺情报',
    notFound: '页面不存在',
    activityCenter: '活动中心',
    lotteryPoster: '抽奖活动海报',
    lottery: '抽奖活动',
    prizeList: '奖品列表',
    aiDeck: 'AI分析',
    exchangeCoupon: '兑换券',
    auctionShare: '竞价分享',
    auctionPoster: '竞价海报',
  },
  // 抽奖
  lottery: {
    rule: '规则',
    prize: '奖品',
    finalExplanation: '*本活动最终解释权归集换社所有',
    viewDetails: '查看详情',
    activityList: '活动列表',
    myParticipation: '我参与的',
    rules: '规则说明',
    iKnow: '我已知晓',
    myPrize: '我的奖品',
    address: '收货地址',
    prizeNotice: '恭喜中奖！请耐心等待集换社管理员联系您兑换奖品。',
    participate: '参与抽奖',
    soonToOpen: '即将开奖',
    openResult: '开奖结果',
    noPrize: '未中奖',
    receivePrize: '领取奖品',
    activitySoonStart: '活动即将开始...',
    clickToParticipate: '点击立即参与抽奖！',
    waitingForResult: '请等待开奖～',
    resultAnnounced: '开奖啦！立即查看你的开奖结果→',
    notWinning: '很遗憾，本场你未中奖！',
    congratulations: '恭喜中奖！',
    lotteryEnded: '本场抽奖已结束～',
    startTime: '开始时间：',
    drawTime: '开奖时间：',
    prizeNotice2: '请及时领取并填写收货地址，已平台发货时填写的地址为准；若发货时还未填写，则视作放弃奖品~',
    keepTrying: '再接再厉，离大奖就差一步啦～',
    congratulationsPrize: '恭喜您中得【{prize}】，\n请尽快领取奖品，错过将过期～',
    claimPrizeReminder: '请尽快领取奖品，错过将过期～',
    drawDate: '{time} 开奖',
    confirm: '确认',
    edit: '编辑',
    updateApp: '抱歉，当前版本过旧，请先升级APP后再选择地址',
    competitionQualification: '比赛资格',
    pm_H5_luckyDraw_winning: "恭喜中奖！优惠券已发放至您的账户中！您可前往「我的」/「优惠券」中查看~",
    pm_H5_luckyDraw_my_address:'确认地址'
  },
  // 兑换券
  exchangeCoupon: {
    pm_H5exchange_coupon_description: "详细说明",
    pm_H5exchange_coupon_btn_not_started: "请等待活动开始",
    pm_H5exchange_coupon_btn_login: "请先登录",
    pm_H5exchange_coupon_btn_no_usage_eligibility: "您未获得参与资格",
    pm_H5exchange_coupon_btn_used: "已成功兑换",
    pm_H5exchange_coupon_btn_can_use: "点击此处使用",
    pm_H5exchange_coupon_btn_ended: "活动已结束",
    pm_H5exchange_coupon_anti_fraud_limit: "您当前使用的设备已参与过本活动，请更换设备后再尝试",
    pm_H5exchange_coupon_chooseShop: "请选择要兑换的门店",
    pm_H5exchange_coupon_cancellation_operation: "核销操作",
    pm_H5exchange_coupon_shop: "核销门店",
    pm_H5exchange_coupon_show_this_page: "请将此页面展示给",
    pm_H5exchange_coupon_carry_out: "进行核销",
    pm_H5exchange_coupon_cannot_be_withdrawn: "使用后无法撤销。请交给工作人员操作，不要自己进行核销。",
    pm_H5exchange_coupon_confirm_usage: "点击此处确认使用",
    pm_H5exchange_coupon_confirm_usage2: "已确认使用",
    pm_H5exchange_coupon_confirm_close: "关闭",
    pm_H5exchange_coupon_cancel_verification: "取消本次核销"
  },
  // AI新闻
  aiNews: {
    time: '7×24H',
    source: '来源',
    pm_news_slogan: '7×24小时跟踪全球卡牌资讯',
    pm_app_slogan: '发现卡牌新世界！',
    pm_news_details_share_poster_scan: '扫描二维码 查看详情',
    sourceText: '用户上传',
  },
  // AI扫描介绍页
  aiScanIntroduce: {
    pm_batch_cards_indentify_tutorial_action_start: "我知道了,立即体验「拍照查卡」",
    pm_batch_cards_indentify_deck_tutorial_action_start: "我知道了,立即上传卡组构筑图",
    pm_batch_cards_indentify_collection_tutorial_action_start: "我知道了,立即体验「拍照录入卡册」",
    pm_batch_cards_indentify_sell_tutorial_action_start: "我知道了,立即体验「拍照上架商品」",
  },
  // 拍卖分享
  auction: {
    biddingRecords: '竞价记录',
    auctionInfo: '竞价信息',
    endTime: '结束时间',
    startingPrice: '起拍价',
    deposit: '保证金',
    productDescription: '商品描述',
    noDescription: '暂无描述',
    purchaseTip: '购买提醒：二手物品不支持七天无理由退换货',
    sellerInfo: '卖家信息',
    area: '地区',
    ago: '前',
    minutesAgo: '{n}分钟',
    hoursAgo: '{n}小时',
    daysAgo: '{n}天',
    followers: '粉丝',
    turnover: '成交量',
    avgShipTime: '平均发货时间',
    startTime: '开始时间',
    distanceEndTime: '距结束',
    endTimeText: '已结束',
    completedLabel: '成交：',
    highestBid: '当前价',
    auctionEnds: '竞价结束',
    shareAt: '分享于:',
    leading: '领先',
    out: '出局',
    winnerMessage: '恭喜 {username} 以 {price} 胜出!!!',
    transactionPrice:"成交价",
    status:"状态.",
    currentPriceLabel: '当前价格:',
    placeBid: '出价',
    year: '年',
    month: '月',
    day: '日',
    hour: '时',
    minute: '分',
    dayCountdown: '天',
    second: '秒',
    soldAt: '成交于',
    auctionDeleted: '竞价已被删除',
  },
  // ai卡组
  aiDeck: {
    // 战力图谱
    // 宝可梦
    locale_pkm_damage_output: "进攻",
    locale_pkm_search_consistency: "检索",
    locale_pkm_draw_power: "抽牌",
    locale_pkm_disruption: "干扰",
    locale_pkm_durability: "耐久",
    locale_pkm_versatility: "灵活",

    // 游戏王
    locale_ygo_combo_potential: "展开能力",
    locale_ygo_handtrap_resilience: "手坑抗性",
    locale_ygo_versatility: "妥协与灵活度",
    locale_ygo_board_breaking_power: "解场能力",
    locale_ygo_resource_looping: "资源续航",

    locale_winning_keys: "核心战术",
    locale_meta_fit: "环境适配度",
    locale_main_play: "主要玩法",
    locale_gameplay_first_turn: "我方先攻",
    locale_gameplay_second_turn: "我方后攻",
    locale_counter_guide: "克制指南",
    locale_counter_guide_title: "针对指南",
    locale_counter_guide_opponent_first: "对方先攻",
    locale_counter_guide_opponent_second: "对方后攻",
    locale_card_analysis: "单卡解析",
    locale_starting_approach: "起手策略",
    locale_phase_management: "各阶段打法",
    locale_comeback_tactics: "劣势应对",
    pm_deck_diagnosis_details_main_issue: "主要问题",
    locale_power_chart: "战力图谱",
    locale_surrender_text: "如果出现这个情况，可以考虑投降了",
    locale_investment_number: "投入数量",
    locale_ai: "AI",
    locale_deck_power_chart: "卡组战力图谱",
    locale_my_decks_ai_btn_text: "上传卡组，获取专属分析",
    locale_my_decks_ai_btn_tag_text: "新用户限时免费!",
    // AI卡组分析-卡牌列表-心愿单
    locale_ai_add_to_wishlist: "加心愿单",
    locale_mainstream_matchups: "环境主流应对",
    locale_optimizations: "可调整方向",

    pm_deck_diagnosis_ratingLevel_S: "强力卡组",
    pm_deck_diagnosis_ratingLevel_A: "值得一试",
    pm_deck_diagnosis_ratingLevel_B: "娱乐卡组",
    pm_deck_diagnosis_ratingLevel_C: "建议重组",

    pm_deck_diagnosis_details_analyzingTime: "AI已思考",

    pm_deck_diagnosis_details_share_poster_scanqrcode: "扫描二维码 查看详细分析",
    pm_deck_diagnosis_details_share_poster_userDeck_slogan: "给你的卡组做一次「专业诊断」",
    pm_deck_diagnosis_details_share_poster_topDeck_slogan: "带你全面解析每一个上位卡组",
    pm_deck_diagnosis_details_share_poster_strategy: "先攻/后攻打法",
    pm_deck_diagnosis_details_share_poster_suggestions: "卡组优化建议",
    pm_deck_diagnosis_details_share_link_bottom_button: "打开App查看更多",
  },
};
